import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
    AppConfigStoreService,
    ConfigStoreResponse,
} from './app-config-store.service';

// Manual ROP overrides live as one document in the App Config Store lambda
// (management-console.reordering) under this key: { overrides: { [pid]: rop } }.
// The reordering settings ('default') and purchase orders ('purchase-orders')
// live under their own keys in the same collection.
const ROP_OVERRIDES_KEY = 'rop-overrides';

interface RopOverridesDoc {
    overrides: Record<number, number>;
}

@Injectable({
    providedIn: 'root',
})
export class RopOverrideService {
    private configStore = inject(AppConfigStoreService);

    // Returns {} until the first save (the lambda answers config: null).
    public getOverrides(): Observable<Record<number, number>> {
        return this.configStore
            .get<Partial<RopOverridesDoc>>(ROP_OVERRIDES_KEY)
            .pipe(map((config) => config?.overrides ?? {}));
    }

    public saveOverrides(
        overrides: Record<number, number>,
    ): Observable<ConfigStoreResponse<RopOverridesDoc>> {
        return this.configStore.set(ROP_OVERRIDES_KEY, { overrides });
    }
}
